import React, { useState, useEffect } from 'react';
import Icon from 'components/AppIcon';

const SetRateModal = ({ lawyers, selectedLawyerId, isAdminOrPartner, currentUserId, onSave, onClose }) => {
  const [lawyerId, setLawyerId] = useState(selectedLawyerId || currentUserId || '');
  const [baseHourlyRate, setBaseHourlyRate] = useState('');
  const [effectiveDate, setEffectiveDate] = useState(new Date()?.toISOString()?.split('T')?.[0]);
  const [notes, setNotes] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (selectedLawyerId) setLawyerId(selectedLawyerId);
  }, [selectedLawyerId]);

  const validate = () => {
    const newErrors = {};
    if (!lawyerId) newErrors.lawyerId = 'Please select a lawyer';
    if (!baseHourlyRate || Number(baseHourlyRate) <= 0) newErrors.baseHourlyRate = 'Valid rate required';
    if (!effectiveDate) newErrors.effectiveDate = 'Effective date required';
    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (!validate()) return;
    onSave({ lawyerId, baseHourlyRate: Number(baseHourlyRate), effectiveDate, notes });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-surface rounded-2xl border border-border w-full max-w-md shadow-xl">
        <div className="flex items-center justify-between px-6 py-4 border-b border-border">
          <h2 className="font-heading-semibold text-text-primary">Set Hourly Rate</h2>
          <button onClick={onClose} className="p-2 hover:bg-secondary-50 rounded-lg transition-colors">
            <Icon name="X" size={18} />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {isAdminOrPartner && lawyers?.length > 0 && (
            <div>
              <label className="block text-sm font-body-medium text-text-secondary mb-1.5">Lawyer <span className="text-error-500">*</span></label>
              <select
                value={lawyerId}
                onChange={e => setLawyerId(e?.target?.value)}
                className={`w-full px-3 py-2.5 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary bg-surface ${
                  errors?.lawyerId ? 'border-error-300' : 'border-border'
                }`}
              >
                <option value="">Select lawyer...</option>
                {lawyers?.map(l => (
                  <option key={l?.id} value={l?.id}>{l?.full_name} ({l?.email})</option>
                ))}
              </select>
              {errors?.lawyerId && <p className="text-xs text-error-500 mt-1">{errors?.lawyerId}</p>}
            </div>
          )}
          <div>
            <label className="block text-sm font-body-medium text-text-secondary mb-1.5">Base Hourly Rate (KES) <span className="text-error-500">*</span></label>
            <input
              type="number"
              value={baseHourlyRate}
              onChange={e => setBaseHourlyRate(e?.target?.value)}
              min="0"
              step="500"
              placeholder="e.g. 15000"
              className={`w-full px-3 py-2.5 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary ${
                errors?.baseHourlyRate ? 'border-error-300' : 'border-border'
              }`}
            />
            {errors?.baseHourlyRate && <p className="text-xs text-error-500 mt-1">{errors?.baseHourlyRate}</p>}
          </div>
          <div>
            <label className="block text-sm font-body-medium text-text-secondary mb-1.5">Effective Date <span className="text-error-500">*</span></label>
            <input
              type="date"
              value={effectiveDate}
              onChange={e => setEffectiveDate(e?.target?.value)}
              className={`w-full px-3 py-2.5 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary ${
                errors?.effectiveDate ? 'border-error-300' : 'border-border'
              }`}
            />
            {errors?.effectiveDate && <p className="text-xs text-error-500 mt-1">{errors?.effectiveDate}</p>}
          </div>
          <div>
            <label className="block text-sm font-body-medium text-text-secondary mb-1.5">Notes</label>
            <textarea
              value={notes}
              onChange={e => setNotes(e?.target?.value)}
              placeholder="Reason for rate change..."
              rows={3}
              className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary resize-none"
            />
          </div>
          <div className="flex items-center gap-3 pt-2">
            <button
              type="submit"
              className="flex-1 bg-primary text-white py-2.5 rounded-lg font-body-medium hover:bg-primary-700 transition-colors"
            >
              Set Rate
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 border border-border py-2.5 rounded-lg text-sm font-body-medium text-text-secondary hover:bg-secondary-50 transition-colors"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SetRateModal;
